<template>

  <v-layout
    row
    wrap
  >
    <v-flex
      xs12
      md8
    >
      <v-card class="pa-3">
        <div class="mb-3" >
          <h1 class="display-1 mb-3">{{ translator.name }}&#x200E; <v-chip color="orange" outline small disabled v-if="translator.recommended"><v-avatar><v-icon>star</v-icon></v-avatar>מומלץ</v-chip><v-chip color="light-green" small disabled text-color="white" v-if="translator.callFirst">ליצור קשר ראשון</v-chip></h1>
        </div>

        <vue-markdown
          :source="translator.description || 'אין תיאור'"
          class="markdown"
        ></vue-markdown>

        <div v-if="languages.length">
          <h5 class="subheading font-weight-bold">{{ languages.length > 1 ? "שפות" : "שפה" }}</h5>
          <p>{{ languages.map(item => { return item.title }).join(", ") }}</p>
        </div>
      </v-card>
      <v-card class="pa-3 mt-3" v-if="shouldShow(['ADMIN', 'RESEARCHER'], user)">
        <h2>הערות חוקר/ת</h2>
        <vue-markdown
          :source="translator.researcherNotes || 'אין הערות חוקר/ת'"
          class="markdown"
        ></vue-markdown>
      </v-card>
      <v-layout
        row
        wrap
        class="ma-3"
      >
        <v-flex
          xs12
          md4
        >
          <h3 class="body-2 grey--text">נוצר בתאריך</h3>
          <span class="title">{{ format(translator.created, 'DD/MM/YYYY') }}</span>
        </v-flex>
        <v-flex
          xs12
          md4
        >
          <h3 class="body-2 grey--text">אימות פרטים</h3>
          <span class="title">{{ format(translator.lastValidation, 'DD/MM/YYYY') }}</span>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      md4
    >
      <v-card>
        <v-card-title>
          <h3 class="title">אנשי קשר</h3>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            @click="create"
            v-if="shouldShow(['ADMIN', 'RESEARCHER'], user)"
          >
            <v-icon>add</v-icon> הוספה
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-expansion-panel
          class="elevation-0"
          :value="0"
        >
          <v-expansion-panel-content
            v-for="contact in contacts"
            :key="contact._id"
          >
            <template v-slot:header>
              <span class="title">{{ contact.name }} <v-chip v-if="contact.callFirst" color="light-green" small disabled class="white--text">ליצור קשר ראשון</v-chip></span>
            </template>
            <contact
              :contact="contact"
              :parent-resource="$store.state.resources.translator"
              :parent-id="translatorId"
              :roles="['ADMIN', 'RESEARCHER']"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-card>

      <translator-events
        :translator-id="translatorId"
        class="mt-3"
      />

    </v-flex>
  </v-layout>
</template>

<script>
import { format } from "date-fns";
import Mixins from "@/mixins/mixins";
import Contact from "../../Contact.vue";
import TranslatorEvents from "./TranslatorEvents.vue";
import { mapState } from "vuex";
import generateId from "@/idGenerator";
import VueMarkdown from "vue-markdown";
import shouldShow from "@/utils/shouldShow";

export default {
  data() {
    return {
      removing: []
    };
  },
  computed: {
    ...mapState({
      resource: state => state.resources.translator
    }),
    translatorId() {
      return this.$route.params.id;
    },
    translator() {
      return this.$store.getters["entity"]("translators", this.translatorId);
    },
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    },
    user() {
      return this.$store.getters["user/user"];
    },
    contacts() {
      let contacts = this.$store.getters["translators/contacts"](this.translatorId);
      let sorted = contacts.sort((a, b) => {
        if (a.callFirst && b.callFirst || !a.callFirst && !b.callFirst) return 0;
        else if (a.callFirst) return -1;
        else if (b.callFirst) return 1;
      })
      return sorted;
    },
    languages() {
      return (this.translator.languages || []).map(item => {
        let language = this.$store.state.entities.languages[item];
        return language;
      }).filter(item => { return !!item })
    }
  },
  methods: {
    format,
    shouldShow,
    create() {
      let newEntity = { _id: generateId(), translator: this.translatorId };
      this.edit(newEntity, true);
    },
    edit(entity, isNew = false) {
      let resource = this.$store.state.resources.contact;
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: resource.schema
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource,
        isNew
      });
      this.entityEditDialog = true;
    }
  },
  components: {
    Contact,
    VueMarkdown,
    TranslatorEvents
  },
  mixins: [Mixins]
};
</script>

<style lang="scss">
.markdown {
  table {
    border: 1px solid #ddd;
  }
  td,
  th {
    text-align: right !important;
    padding: 10px;
    border: 1px solid #ddd;
  }
  tr {
    padding: 5px 0 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/translators/translator/GeneralDetails.vue